import { render, staticRenderFns } from "./HomeDefault.vue?vue&type=template&id=36712171&scoped=true&"
import script from "./HomeDefault.vue?vue&type=script&lang=js&"
export * from "./HomeDefault.vue?vue&type=script&lang=js&"
import style0 from "./HomeDefault.vue?vue&type=style&index=0&id=36712171&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36712171",
  null
  
)

export default component.exports